import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmReturnVisitSaveAPI } from '@/api/crm/visit';

import XrCreate from '@/components/XrCreate';
import CreateSections from '@/components/CreateSections';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';
import { CrmRelativeCell } from '@/components/CreateCom';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { objDeepCopy } from '@/utils';
// import { isEmpty } from '@/utils/types'

export default {
  // 新建编辑
  name: 'VisitCreate',

  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    CrmRelativeCell: CrmRelativeCell,
    WkFormItems: WkFormItems
  },

  mixins: [CustomFieldsMixin],

  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {}
    };
  },


  computed: {
    title: function title() {
      return this.action.type === 'update' ? '编辑回访' : '新建回访';
    }
  },

  watch: {},

  created: function created() {
    this.getField();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        // label: crmTypeModel.visit
        types: 'crm_visit',
        module: 'crm',
        controller: 'visit',
        action: this.action.type,
        format: 2
      };

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];
        var assistIds = _this.getFormAssistIds(list);

        var baseFields = [];
        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (canEdit) {
              // 自动生成编号
              if (item.autoGeneNumber == 1) {
                temp.placeholder = '根据编号规则自动生成，支持手动输入';
                var copyItem = objDeepCopy(item);
                copyItem.isNull = 0;
                fieldRules[temp.field] = _this.getRules(copyItem);
              } else {
                fieldRules[temp.field] = _this.getRules(item);
              }
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 禁止某些业务组件选择 仅新建限制
            if (temp.form_type == 'contacts' || temp.form_type == 'contract' || temp.form_type == 'customer') {
              if (_this.action.type == 'relative') {
                var relativeDisInfos = {
                  customer: { customer: true },
                  contract: { customer: true, contract: true }

                  // 在哪个类型下添加
                };var relativeTypeDisInfos = relativeDisInfos[_this.action.crmType];
                if (relativeTypeDisInfos) {
                  // 包含的字段值
                  temp.disabled = relativeTypeDisInfos[item.form_type] || false;
                }
              } else if (_this.action.type == 'save') {
                temp.disabled = item.form_type === 'contract' || item.form_type === 'contacts';
              }
            }

            // 处理关联
            if (_this.action.type == 'save') {
              if (item.form_type == 'contract') {
                temp['relation'] = {};
              }
            }
            if (_this.action.type == 'relative' || _this.action.type == 'update') {
              var customerItem = _this.getItemRelatveInfo(list, 'customer');
              if (customerItem) {
                if (item.form_type == 'contacts') {
                  customerItem['moduleType'] = 'customer';
                  temp['relation'] = customerItem;
                } else if (item.form_type == 'contract') {
                  customerItem['moduleType'] = 'customer';
                  customerItem['params'] = { check_status: 2 };
                  temp['relation'] = customerItem;
                }
              }
            }

            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            // 获取默认值
            if (temp.show) {
              fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this2 = this;

      var isDraft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loading = true;
      var crmForm = this.$refs.crmForm;
      crmForm.validate(function (valid) {
        if (valid) {
          var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);

          // this.submiteParams(params)
          if (_this2.action.type === 'update') {
            params.action_id = _this2.action.id;
          }
          _this2.submiteParams(params);
        } else {
          _this2.loading = false;
          // 提示第一个error
          _this2.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },


    /**
     * 提交上传
     */
    submiteParams: function submiteParams(params) {
      var _this3 = this;

      if (this.action.type == 'update') {
        params.id = this.action.id;
        params.batchId = this.action.batchId;
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && _Object$keys(this.action.relativeData).length) {
        params = _extends({}, params, this.action.relativeData);
      }

      crmReturnVisitSaveAPI(params).then(function (res) {
        _this3.loading = false;

        _this3.$message.success(_this3.action.type == 'update' ? '编辑成功' : '添加成功');

        _this3.close();

        // 保存成功
        _this3.$emit('save-success', {
          type: 'visit'
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },


    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      // 审批流逻辑
      // this.debouncedGetWkFlowList(field.field, this.fieldForm)

      if (['select', 'checkbox'].includes(field.formType) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },


    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      var _this4 = this;

      if (field.form_type === 'customer') {
        this.itemsForEach(this.fieldList, function (fieldItem) {
          if (fieldItem.form_type === 'contract' || fieldItem.form_type === 'contacts') {
            if (data.value.length > 0) {
              fieldItem.disabled = false;
              var customerItem = data.value[0];
              customerItem['moduleType'] = 'customer';
              customerItem['params'] = { check_status: 2 };
              fieldItem['relation'] = customerItem;
            } else {
              fieldItem.disabled = true;
              fieldItem['relation'] = {};
              _this4.fieldForm[fieldItem.field] = [];
            }
          }
        });
      }
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    }
  }
};